export default {"src":"/_next/static/media/people_call.a9d8ddd1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};